"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextAreaStyled = void 0;
exports.getPadding = getPadding;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _formInputTheme = require("../../textinput/styled/formInputTheme");
const TextAreaStyled = (0, _styled.default)("textarea")`
    background-color: ${_formInputTheme.getBackgroundColor};
    max-height: ${_ref => {
  let {
    maxHeight
  } = _ref;
  return maxHeight && maxHeight !== "none" ? maxHeight : "none";
}};
    word-break: break-word;

    // needed to position the error message correctly
    min-height: ${_ref2 => {
  let {
    minHeight
  } = _ref2;
  return minHeight && minHeight !== "none" ? minHeight : "none";
}};

    padding: ${getPadding};

    resize: none;
    color: inherit;
    &::placeholder {
        color: ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return _formInputTheme.formInputTheme.placeholderColor.rest(themeMode);
}};
    }
    &[aria-disabled="true"] {
        cursor: not-allowed;
    }
`;
exports.TextAreaStyled = TextAreaStyled;
const paddingTopVar = "--smar--sds--textarea--padding-top";
const paddingRightVar = "--smar--sds--textarea--padding-right";
const paddingBottomVar = "--smar--sds--textarea--padding-bottom";
const paddingLeftVar = "--smar--sds--textarea--padding-left";
function getPadding(_ref4) {
  let {
    themeMode,
    validationState,
    isFocused,
    focusMode
  } = _ref4;
  if (validationState === "error") {
    return `
        var(${paddingTopVar}, ${_formInputTheme.formInputTheme.padding.top.error(themeMode)}px)
        var(${paddingRightVar}, 5px) 
        var(${paddingBottomVar},${_formInputTheme.formInputTheme.padding.bottom.error(themeMode)}px)
        var(${paddingLeftVar},${_formInputTheme.formInputTheme.padding.default.error(themeMode)}px)`;
  } else if (isFocused && focusMode !== "keyboard") {
    return `
        var(${paddingTopVar}, ${_formInputTheme.formInputTheme.padding.top.active(themeMode)}px)
        var(${paddingRightVar}, 5px) 
        var(${paddingBottomVar},${_formInputTheme.formInputTheme.padding.bottom.active(themeMode)}px)
        var(${paddingLeftVar},${_formInputTheme.formInputTheme.padding.default.active(themeMode)}px)`;
  } else {
    return `
        var(${paddingTopVar}, ${_formInputTheme.formInputTheme.padding.top.rest(themeMode)}px)
        var(${paddingRightVar}, 6px)  
        var(${paddingBottomVar},${_formInputTheme.formInputTheme.padding.bottom.rest(themeMode)}px)
        var(${paddingLeftVar},${_formInputTheme.formInputTheme.padding.default.rest(themeMode)}px)`;
  }
}
//# sourceMappingURL=TextAreaStyled.js.map